import FormHeader from 'components/Form/FormHeader';
import FormResult from 'components/Form/FormResult';
import NavigationTabs from 'components/Navigation/NavigationTabs';
import useBeforeUnload from 'hooks/useBeforeUnload';
import {setMessage} from 'hooks/useMessage';
import lodash from 'lodash';
import {FC} from 'react';
import {FormProvider, useForm} from 'react-hook-form';
import {useBackend} from 'state/backend';
import {c} from 'ttag';
import {setUrl} from 'utils/request';
import {onApiError} from 'utils/request-axios/utils';

import {
    FavouriteTemplateFormFields,
    usePutFavouriteTemplateEdit,
} from '../services';
import {
    FavouriteTemplatePostData,
    FavouriteTemplatesEditBackendData,
} from '../types';
import Section from './Section';

const EditFavouriteTemplatePage: FC = () => {
    const {data, flags} = useBackend<FavouriteTemplatesEditBackendData>();

    const methods = useForm<FavouriteTemplateFormFields>({
        defaultValues: {
            favouriteTemplates: data.favouriteTemplates,
        },
    });

    const {isLoading, mutateAsync} = usePutFavouriteTemplateEdit();

    const {favouriteTemplates} = methods.watch();

    const {allowPageChange} = useBeforeUnload(
        !lodash.isEqual(
            {
                favouriteTemplates,
            },
            {
                favouriteTemplates: data.favouriteTemplates,
            },
        ),
    );

    const cleanFormData = () => {
        const templateData: FavouriteTemplatePostData = [];

        if (favouriteTemplates) {
            favouriteTemplates.forEach((template) => {
                template.documentTypes.forEach((documentType) => {
                    templateData.push({
                        documentType,
                        templateCode: template.templateCode,
                    });
                });
            });
        }

        return templateData;
    };

    const onSubmit = () => {
        mutateAsync({favouriteTemplates: cleanFormData()})
            .then(() => {
                allowPageChange();
                setUrl(window.Urls.favourite_template_view());
                setMessage(
                    'successMessage',
                    c('component').t`Settings have been saved.`,
                );
            })
            .catch(onApiError(methods));
    };

    return (
        <div>
            <FormProvider {...methods}>
                <FormResult className="mb-4" />
                <NavigationTabs.DocumentSettings
                    flags={flags}
                    selection="favouriteTemplate"
                />
                <FormHeader
                    button={{
                        isLoading,
                        kind: 'primary',
                        label: c('component').t`Save`,
                        onClick: onSubmit,
                        type: 'submit',
                    }}
                    subtitle={c('component')
                        .t`Select and order the Templates that appear at the top of the Document Template picker.`}
                    title={c('component').t`Favorite Templates`}
                />
                <Section />
            </FormProvider>
        </div>
    );
};

export default EditFavouriteTemplatePage;
